import "./PageContainer.css";


export const PageContainer = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="page-container">
            <div className="page-body">
                {children}
            </div>
        </div>
    )
}